export default {
  getMapQuery: (state) => state.mapQuery,
};
